export const mostAccessedMenu = [
  {
    funcionality: "Inventário rotativo",
    access: '9.000',
    tendency: '63',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2,
  },

  {
    funcionality: "Ajuste pontual",
    access: '5.000',
    tendency: '-20.5',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2
  },

  {
    funcionality: "Aprovação de demarca",
    access: '3.000',
    tendency: '20.9',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2
  },

  {
    funcionality: "Conferência linear",
    access: '1.000',
    tendency: '20',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2
  },

  {
    funcionality: "Demarca",
    access: '500',
    tendency: '-50',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2
  },

  {
    funcionality: "Analytics",
    access: '9.000',
    tendency: '63',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1
  },
  {
    funcionality: "Ruptura visual",
    access: '5.000',
    tendency: '-20.5',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1
  },

  {
    funcionality: "Conferência do linear",
    access: '3.000',
    tendency: '20.9',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1
  },

  {
    funcionality: "Demarca",
    access: '1.000',
    tendency: '20',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1
  },

  {
    funcionality: "Transferência entre depósitos",
    access: '500',
    tendency: '0',
    mostAccessLdap: '51015700',
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1
  },
]


export const mostAccessedMenuDetails = [
  {
    relatory: 'Ajustes Realizados',
    funcionality: "Ruptura visual",
    access: '150',
    tendency: '63',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2,
    '0001': 2,
    '0002': 5,
    '0003': 5,
    '0004': 5,
    '0005': 5,
    '0007': 5,
    '0008': 5,
    '0009': 5,
    '0010': 5,
    '0011': 5,
    '0012': 5,
    '0013': 5,
    '0015': 5,
    '0016': 5,
    '0017': 5,
    '0018': 5,
    '0019': 5,
    '0020': 5,
    '0021': 5,
    '0022': 5,
    '0023': 5,
    '0024': 5,
    '0026': 5,
    '0027': 5,
    '0028': 5,
    '0029': 5,
    '0032': 5,
    '0033': 5,
    '0034': 5,
    '0035': 5,
    '0036': 5,
    '0038': 5,
    '0039': 5,
    '0041': 5,
    '0042': 5,
    '0044': 5,
    '0045': 5,
    '0046': 5,
    '0049': 5,
    '0050': 5,
    '0055': 5,
    '0057': 5,
    '0058': 5,
    '0059': 5,
    '0062': 5,
    '0063': 5,
    '0065': 5,
  },
  {
    relatory: 'Analytics',
    funcionality: "Status de solicitações",
    access: '100',
    tendency: '-20.5',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2,
    '0001': 5,
    '0002': 8,
    '0003': 8,
    '0004': 8,
    '0005': 8,
    '0007': 8,
    '0008': 8,
    '0009': 8,
    '0010': 8,
    '0011': 8,
    '0012': 8,
    '0013': 8,
    '0015': 8,
    '0016': 8,
    '0017': 8,
    '0018': 8,
    '0019': 8,
    '0020': 8,
    '0021': 8,
    '0022': 8,
    '0023': 8,
    '0024': 8,
    '0026': 8,
    '0027': 8,
    '0028': 8,
    '0029': 8,
    '0032': 8,
    '0033': 8,
    '0034': 8,
    '0035': 8,
    '0036': 8,
    '0038': 8,
    '0039': 8,
    '0041': 8,
    '0042': 8,
    '0044': 8,
    '0045': 8,
    '0046': 8,
    '0049': 8,
    '0050': 8,
    '0055': 8,
    '0057': 8,
    '0058': 8,
    '0059': 8,
    '0062': 8,
    '0063': 8,
    '0065': 8,
  },

  {
    relatory: 'Coaching de vendas',
    funcionality: "Solicitar nova demarca",
    access: '80',
    tendency: '20.9',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2,
    '0001': 8,
    '0002': 5,
    '0003': 5,
    '0004': 5,
    '0005': 5,
    '0007': 5,
    '0008': 5,
    '0009': 5,
    '0010': 5,
    '0011': 5,
    '0012': 5,
    '0013': 5,
    '0015': 5,
    '0016': 5,
    '0017': 5,
    '0018': 5,
    '0019': 5,
    '0020': 5,
    '0021': 5,
    '0022': 5,
    '0023': 5,
    '0024': 5,
    '0026': 5,
    '0027': 5,
    '0028': 5,
    '0029': 5,
    '0032': 5,
    '0033': 5,
    '0034': 5,
    '0035': 5,
    '0036': 5,
    '0038': 5,
    '0039': 5,
    '0041': 5,
    '0042': 5,
    '0044': 5,
    '0045': 5,
    '0046': 5,
    '0049': 5,
    '0050': 5,
    '0055': 5,
    '0057': 5,
    '0058': 5,
    '0059': 5,
    '0062': 5,
    '0063': 5,
    '0065': 5,
  },

  {
    relatory: 'Conferencia do Linear',
    funcionality: "Novidades",
    access: '70',
    tendency: '20',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2,
    '0001': 8,
    '0002': 5,
    '0003': 5,
    '0004': 5,
    '0005': 5,
    '0007': 5,
    '0008': 5,
    '0009': 5,
    '0010': 5,
    '0011': 5,
    '0012': 5,
    '0013': 5,
    '0015': 5,
    '0016': 5,
    '0017': 5,
    '0018': 5,
    '0019': 5,
    '0020': 5,
    '0021': 5,
    '0022': 5,
    '0023': 5,
    '0024': 5,
    '0026': 5,
    '0027': 5,
    '0028': 5,
    '0029': 5,
    '0032': 5,
    '0033': 5,
    '0034': 5,
    '0035': 5,
    '0036': 5,
    '0038': 5,
    '0039': 5,
    '0041': 5,
    '0042': 5,
    '0044': 5,
    '0045': 5,
    '0046': 5,
    '0049': 5,
    '0050': 5,
    '0055': 5,
    '0057': 5,
    '0058': 5,
    '0059': 5,
    '0062': 5,
    '0063': 5,
    '0065': 5,
  },

  {
    relatory: 'Demarca',
    funcionality: "Editor de tutoriais",
    access: '62',
    tendency: '-50',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 2,
    '0001': 5,
    '0002': 8,
    '0003': 8,
    '0004': 8,
    '0005': 8,
    '0007': 8,
    '0008': 8,
    '0009': 8,
    '0010': 8,
    '0011': 8,
    '0012': 8,
    '0013': 8,
    '0015': 8,
    '0016': 8,
    '0017': 8,
    '0018': 8,
    '0019': 8,
    '0020': 8,
    '0021': 8,
    '0022': 8,
    '0023': 8,
    '0024': 8,
    '0026': 8,
    '0027': 8,
    '0028': 8,
    '0029': 8,
    '0032': 8,
    '0033': 8,
    '0034': 8,
    '0035': 8,
    '0036': 8,
    '0038': 8,
    '0039': 8,
    '0041': 8,
    '0042': 8,
    '0044': 8,
    '0045': 8,
    '0046': 8,
    '0049': 8,
    '0050': 8,
    '0055': 8,
    '0057': 8,
    '0058': 8,
    '0059': 8,
    '0062': 8,
    '0063': 8,
    '0065': 8,
  },

  {
    relatory: 'Histórico de contageem do IRC',
    funcionality: "Motor de promoções",
    access: '32',
    tendency: '63',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1,
    '0001': 2,
    '0002': 8,
    '0003': 8,
    '0004': 8,
    '0005': 8,
    '0007': 8,
    '0008': 8,
    '0009': 8,
    '0010': 8,
    '0011': 8,
    '0012': 8,
    '0013': 8,
    '0015': 8,
    '0016': 8,
    '0017': 8,
    '0018': 8,
    '0019': 8,
    '0020': 8,
    '0021': 8,
    '0022': 8,
    '0023': 8,
    '0024': 8,
    '0026': 8,
    '0027': 8,
    '0028': 8,
    '0029': 8,
    '0032': 8,
    '0033': 8,
    '0034': 8,
    '0035': 8,
    '0036': 8,
    '0038': 8,
    '0039': 8,
    '0041': 8,
    '0042': 8,
    '0044': 8,
    '0045': 8,
    '0046': 8,
    '0049': 8,
    '0050': 8,
    '0055': 8,
    '0057': 8,
    '0058': 8,
    '0059': 8,
    '0062': 8,
    '0063': 8,
    '0065': 8,
  },
  {
    relatory: 'Histórico de contageem do IRC',
    funcionality: "Emitir nota fiscal de demarca",
    access: '20',
    tendency: '-20.5',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1,
    '0001': 2,
    '0002': 2,
    '0003': 2,
    '0004': 2,
    '0005': 2,
    '0007': 2,
    '0008': 2,
    '0009': 2,
    '0010': 2,
    '0011': 2,
    '0012': 2,
    '0013': 2,
    '0015': 2,
    '0016': 2,
    '0017': 2,
    '0018': 2,
    '0019': 2,
    '0020': 2,
    '0021': 2,
    '0022': 2,
    '0023': 2,
    '0024': 2,
    '0026': 2,
    '0027': 2,
    '0028': 2,
    '0029': 2,
    '0032': 2,
    '0033': 2,
    '0034': 2,
    '0035': 2,
    '0036': 2,
    '0038': 2,
    '0039': 2,
    '0041': 2,
    '0042': 2,
    '0044': 2,
    '0045': 2,
    '0046': 2,
    '0049': 2,
    '0050': 2,
    '0055': 2,
    '0057': 2,
    '0058': 2,
    '0059': 2,
    '0062': 2,
    '0063': 2,
    '0065': 2,
  },

  {
    relatory: 'Histórico de contageem do IRC',
    funcionality: "Solicitar nova demarca",
    access: '2',
    tendency: '20.9',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1,
    '0001': 8,
    '0002': 0,
    '0003': 0,
    '0004': 0,
    '0005': 0,
    '0007': 0,
    '0008': 0,
    '0009': 0,
    '0010': 0,
    '0011': 0,
    '0012': 0,
    '0013': 0,
    '0015': 0,
    '0016': 0,
    '0017': 0,
    '0018': 0,
    '0019': 0,
    '0020': 0,
    '0021': 0,
    '0022': 0,
    '0023': 0,
    '0024': 0,
    '0026': 0,
    '0027': 0,
    '0028': 0,
    '0029': 0,
    '0032': 0,
    '0033': 0,
    '0034': 0,
    '0035': 0,
    '0036': 0,
    '0038': 0,
    '0039': 0,
    '0041': 0,
    '0042': 0,
    '0044': 0,
    '0045': 0,
    '0046': 0,
    '0049': 0,
    '0050': 0,
    '0055': 0,
    '0057': 0,
    '0058': 0,
    '0059': 0,
    '0062': 0,
    '0063': 0,
    '0065': 0,
  },

  {
    relatory: 'Kardex',
    funcionality: "Notificações",
    access: '0',
    tendency: '20',
    mostAccessLdap: 51015700,
    mostAcessLdapQty: 150,
    mostAccessMission: "ASSESSOR  DE VENDAS",
    mostAccessMissionQty: 150,
    showType: 1,
    '0001': 8,
    '0002': 8,
    '0003': 8,
    '0004': 8,
    '0005': 8,
    '0007': 8,
    '0008': 8,
    '0009': 8,
    '0010': 8,
    '0011': 8,
    '0012': 8,
    '0013': 8,
    '0015': 8,
    '0016': 8,
    '0017': 8,
    '0018': 8,
    '0019': 8,
    '0020': 8,
    '0021': 8,
    '0022': 8,
    '0023': 8,
    '0024': 8,
    '0026': 8,
    '0027': 8,
    '0028': 8,
    '0029': 8,
    '0032': 8,
    '0033': 8,
    '0034': 8,
    '0035': 8,
    '0036': 8,
    '0038': 8,
    '0039': 8,
    '0041': 8,
    '0042': 8,
    '0044': 8,
    '0045': 8,
    '0046': 8,
    '0049': 8,
    '0050': 8,
    '0055': 8,
    '0057': 8,
    '0058': 8,
    '0059': 8,
    '0062': 8,
    '0063': 8,
    '0065': 8,
  },

]



export const versionApp = {
    number: '58.1.2',
    data: [
      {
        "id": "updated",
        "label": "",
        "value": 75,
        "color": "#41a017"
      },

      {
        "id": "notUpdated",
        "label": "",
        "value": 25,
        "color": "#eeeef0"
      }
    ]
}

export const mockEmptyData = [

  {
    "id": "updated",
    "label": "",
    "value": 0,
    "color": "#41a017"
  },

  {
    "id": "notUpdated",
    "label": "",
    "value": 0,
    "color": "#eeeef0"
  },

  {
    "id": "empty",
    "label": "",
    "value": 100,
    "color": "#eeeef0"
  }

]

export const accessQty = {
  lastMonth: {
    value: '10.000',
    tendency: '-50'
  },

  lastDay: {
    value: '20',
    tendency: '70'
  }

}
